export const PLATFORM_OPTIONS = [
  { label: '小红书', value: '小红书' },
  { label: '微信公众号', value: '微信公众号' },
  { label: '微信视频号', value: '微信视频号' },
  { label: '抖音', value: '抖音' },
  { label: '快手', value: '快手' },
  { label: '百家号', value: '百家号' },
  { label: '知乎', value: '知乎' },
  { label: 'B站', value: 'B站' },
  { label: '今日头条', value: '今日头条' },
];

export const openContentManagement = () => {
  const url = `${window.location.origin}/content?tab=raw`;
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const KEYWORDS_TOKEN_SEPARATORS = [',', '，', ';', '；', ' ', '\n', '\t'];

export const normalizeStringArray = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value.map((v) => String(v).trim()).filter(Boolean);
  return String(value)
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean);
};

const splitKeywordsText = (value) => {
  return String(value || '')
    .split(/[,\s，;；]+/u)
    .map((part) => part.trim())
    .filter(Boolean);
};

export const normalizeKeywordsArray = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value.flatMap((item) => splitKeywordsText(item));
  return splitKeywordsText(value);
};

export const normalizeOptionalString = (value) => {
  if (value === null || value === undefined) return undefined;
  const text = String(value).trim();
  return text ? text : undefined;
};

export const parseMultiline = (value) => {
  const text = String(value || '');
  return text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
};
